// Pre-filled country list with ISO code, name, dial code, flag emoji.
// Source: ITU dialing codes + ISO 3166-1.

const C = (code, name, dial, flag) => ({ code, name, dial, flag });

export const COUNTRIES = [
  C("AF", "Afghanistan", "+93", "🇦🇫"),
  C("AL", "Albania", "+355", "🇦🇱"),
  C("DZ", "Algeria", "+213", "🇩🇿"),
  C("AS", "American Samoa", "+1684", "🇦🇸"),
  C("AD", "Andorra", "+376", "🇦🇩"),
  C("AO", "Angola", "+244", "🇦🇴"),
  C("AI", "Anguilla", "+1264", "🇦🇮"),
  C("AG", "Antigua & Barbuda", "+1268", "🇦🇬"),
  C("AR", "Argentina", "+54", "🇦🇷"),
  C("AM", "Armenia", "+374", "🇦🇲"),
  C("AW", "Aruba", "+297", "🇦🇼"),
  C("AU", "Australia", "+61", "🇦🇺"),
  C("AT", "Austria", "+43", "🇦🇹"),
  C("AZ", "Azerbaijan", "+994", "🇦🇿"),
  C("BS", "Bahamas", "+1242", "🇧🇸"),
  C("BH", "Bahrain", "+973", "🇧🇭"),
  C("BD", "Bangladesh", "+880", "🇧🇩"),
  C("BB", "Barbados", "+1246", "🇧🇧"),
  C("BY", "Belarus", "+375", "🇧🇾"),
  C("BE", "Belgium", "+32", "🇧🇪"),
  C("BZ", "Belize", "+501", "🇧🇿"),
  C("BJ", "Benin", "+229", "🇧🇯"),
  C("BM", "Bermuda", "+1441", "🇧🇲"),
  C("BT", "Bhutan", "+975", "🇧🇹"),
  C("BO", "Bolivia", "+591", "🇧🇴"),
  C("BA", "Bosnia & Herzegovina", "+387", "🇧🇦"),
  C("BW", "Botswana", "+267", "🇧🇼"),
  C("BR", "Brazil", "+55", "🇧🇷"),
  C("BN", "Brunei", "+673", "🇧🇳"),
  C("BG", "Bulgaria", "+359", "🇧🇬"),
  C("BF", "Burkina Faso", "+226", "🇧🇫"),
  C("BI", "Burundi", "+257", "🇧🇮"),
  C("KH", "Cambodia", "+855", "🇰🇭"),
  C("CM", "Cameroon", "+237", "🇨🇲"),
  C("CA", "Canada", "+1", "🇨🇦"),
  C("CV", "Cape Verde", "+238", "🇨🇻"),
  C("KY", "Cayman Islands", "+1345", "🇰🇾"),
  C("CF", "Central African Republic", "+236", "🇨🇫"),
  C("TD", "Chad", "+235", "🇹🇩"),
  C("CL", "Chile", "+56", "🇨🇱"),
  C("CN", "China", "+86", "🇨🇳"),
  C("CO", "Colombia", "+57", "🇨🇴"),
  C("KM", "Comoros", "+269", "🇰🇲"),
  C("CG", "Congo", "+242", "🇨🇬"),
  C("CD", "Congo (DRC)", "+243", "🇨🇩"),
  C("CR", "Costa Rica", "+506", "🇨🇷"),
  C("CI", "Côte d'Ivoire", "+225", "🇨🇮"),
  C("HR", "Croatia", "+385", "🇭🇷"),
  C("CU", "Cuba", "+53", "🇨🇺"),
  C("CY", "Cyprus", "+357", "🇨🇾"),
  C("CZ", "Czech Republic", "+420", "🇨🇿"),
  C("DK", "Denmark", "+45", "🇩🇰"),
  C("DJ", "Djibouti", "+253", "🇩🇯"),
  C("DM", "Dominica", "+1767", "🇩🇲"),
  C("DO", "Dominican Republic", "+1809", "🇩🇴"),
  C("EC", "Ecuador", "+593", "🇪🇨"),
  C("EG", "Egypt", "+20", "🇪🇬"),
  C("SV", "El Salvador", "+503", "🇸🇻"),
  C("GQ", "Equatorial Guinea", "+240", "🇬🇶"),
  C("ER", "Eritrea", "+291", "🇪🇷"),
  C("EE", "Estonia", "+372", "🇪🇪"),
  C("ET", "Ethiopia", "+251", "🇪🇹"),
  C("FJ", "Fiji", "+679", "🇫🇯"),
  C("FI", "Finland", "+358", "🇫🇮"),
  C("FR", "France", "+33", "🇫🇷"),
  C("PF", "French Polynesia", "+689", "🇵🇫"),
  C("GA", "Gabon", "+241", "🇬🇦"),
  C("GM", "Gambia", "+220", "🇬🇲"),
  C("GE", "Georgia", "+995", "🇬🇪"),
  C("DE", "Germany", "+49", "🇩🇪"),
  C("GH", "Ghana", "+233", "🇬🇭"),
  C("GR", "Greece", "+30", "🇬🇷"),
  C("GL", "Greenland", "+299", "🇬🇱"),
  C("GD", "Grenada", "+1473", "🇬🇩"),
  C("GU", "Guam", "+1671", "🇬🇺"),
  C("GT", "Guatemala", "+502", "🇬🇹"),
  C("GN", "Guinea", "+224", "🇬🇳"),
  C("GW", "Guinea-Bissau", "+245", "🇬🇼"),
  C("GY", "Guyana", "+592", "🇬🇾"),
  C("HT", "Haiti", "+509", "🇭🇹"),
  C("HN", "Honduras", "+504", "🇭🇳"),
  C("HK", "Hong Kong", "+852", "🇭🇰"),
  C("HU", "Hungary", "+36", "🇭🇺"),
  C("IS", "Iceland", "+354", "🇮🇸"),
  C("IN", "India", "+91", "🇮🇳"),
  C("ID", "Indonesia", "+62", "🇮🇩"),
  C("IR", "Iran", "+98", "🇮🇷"),
  C("IQ", "Iraq", "+964", "🇮🇶"),
  C("IE", "Ireland", "+353", "🇮🇪"),
  C("IL", "Israel", "+972", "🇮🇱"),
  C("IT", "Italy", "+39", "🇮🇹"),
  C("JM", "Jamaica", "+1876", "🇯🇲"),
  C("JP", "Japan", "+81", "🇯🇵"),
  C("JO", "Jordan", "+962", "🇯🇴"),
  C("KZ", "Kazakhstan", "+7", "🇰🇿"),
  C("KE", "Kenya", "+254", "🇰🇪"),
  C("KW", "Kuwait", "+965", "🇰🇼"),
  C("KG", "Kyrgyzstan", "+996", "🇰🇬"),
  C("LA", "Laos", "+856", "🇱🇦"),
  C("LV", "Latvia", "+371", "🇱🇻"),
  C("LB", "Lebanon", "+961", "🇱🇧"),
  C("LS", "Lesotho", "+266", "🇱🇸"),
  C("LR", "Liberia", "+231", "🇱🇷"),
  C("LY", "Libya", "+218", "🇱🇾"),
  C("LI", "Liechtenstein", "+423", "🇱🇮"),
  C("LT", "Lithuania", "+370", "🇱🇹"),
  C("LU", "Luxembourg", "+352", "🇱🇺"),
  C("MO", "Macau", "+853", "🇲🇴"),
  C("MK", "Macedonia", "+389", "🇲🇰"),
  C("MG", "Madagascar", "+261", "🇲🇬"),
  C("MW", "Malawi", "+265", "🇲🇼"),
  C("MY", "Malaysia", "+60", "🇲🇾"),
  C("MV", "Maldives", "+960", "🇲🇻"),
  C("ML", "Mali", "+223", "🇲🇱"),
  C("MT", "Malta", "+356", "🇲🇹"),
  C("MR", "Mauritania", "+222", "🇲🇷"),
  C("MU", "Mauritius", "+230", "🇲🇺"),
  C("MX", "Mexico", "+52", "🇲🇽"),
  C("MD", "Moldova", "+373", "🇲🇩"),
  C("MC", "Monaco", "+377", "🇲🇨"),
  C("MN", "Mongolia", "+976", "🇲🇳"),
  C("ME", "Montenegro", "+382", "🇲🇪"),
  C("MA", "Morocco", "+212", "🇲🇦"),
  C("MZ", "Mozambique", "+258", "🇲🇿"),
  C("MM", "Myanmar (Burma)", "+95", "🇲🇲"),
  C("NA", "Namibia", "+264", "🇳🇦"),
  C("NP", "Nepal", "+977", "🇳🇵"),
  C("NL", "Netherlands", "+31", "🇳🇱"),
  C("NZ", "New Zealand", "+64", "🇳🇿"),
  C("NI", "Nicaragua", "+505", "🇳🇮"),
  C("NE", "Niger", "+227", "🇳🇪"),
  C("NG", "Nigeria", "+234", "🇳🇬"),
  C("KP", "North Korea", "+850", "🇰🇵"),
  C("NO", "Norway", "+47", "🇳🇴"),
  C("OM", "Oman", "+968", "🇴🇲"),
  C("PK", "Pakistan", "+92", "🇵🇰"),
  C("PS", "Palestine", "+970", "🇵🇸"),
  C("PA", "Panama", "+507", "🇵🇦"),
  C("PG", "Papua New Guinea", "+675", "🇵🇬"),
  C("PY", "Paraguay", "+595", "🇵🇾"),
  C("PE", "Peru", "+51", "🇵🇪"),
  C("PH", "Philippines", "+63", "🇵🇭"),
  C("PL", "Poland", "+48", "🇵🇱"),
  C("PT", "Portugal", "+351", "🇵🇹"),
  C("PR", "Puerto Rico", "+1787", "🇵🇷"),
  C("QA", "Qatar", "+974", "🇶🇦"),
  C("RO", "Romania", "+40", "🇷🇴"),
  C("RU", "Russia", "+7", "🇷🇺"),
  C("RW", "Rwanda", "+250", "🇷🇼"),
  C("SM", "San Marino", "+378", "🇸🇲"),
  C("SA", "Saudi Arabia", "+966", "🇸🇦"),
  C("SN", "Senegal", "+221", "🇸🇳"),
  C("RS", "Serbia", "+381", "🇷🇸"),
  C("SC", "Seychelles", "+248", "🇸🇨"),
  C("SL", "Sierra Leone", "+232", "🇸🇱"),
  C("SG", "Singapore", "+65", "🇸🇬"),
  C("SK", "Slovakia", "+421", "🇸🇰"),
  C("SI", "Slovenia", "+386", "🇸🇮"),
  C("SO", "Somalia", "+252", "🇸🇴"),
  C("ZA", "South Africa", "+27", "🇿🇦"),
  C("KR", "South Korea", "+82", "🇰🇷"),
  C("SS", "South Sudan", "+211", "🇸🇸"),
  C("ES", "Spain", "+34", "🇪🇸"),
  C("LK", "Sri Lanka", "+94", "🇱🇰"),
  C("SD", "Sudan", "+249", "🇸🇩"),
  C("SR", "Suriname", "+597", "🇸🇷"),
  C("SE", "Sweden", "+46", "🇸🇪"),
  C("CH", "Switzerland", "+41", "🇨🇭"),
  C("SY", "Syria", "+963", "🇸🇾"),
  C("TW", "Taiwan", "+886", "🇹🇼"),
  C("TJ", "Tajikistan", "+992", "🇹🇯"),
  C("TZ", "Tanzania", "+255", "🇹🇿"),
  C("TH", "Thailand", "+66", "🇹🇭"),
  C("TL", "Timor-Leste", "+670", "🇹🇱"),
  C("TG", "Togo", "+228", "🇹🇬"),
  C("TT", "Trinidad & Tobago", "+1868", "🇹🇹"),
  C("TN", "Tunisia", "+216", "🇹🇳"),
  C("TR", "Türkiye", "+90", "🇹🇷"),
  C("TM", "Turkmenistan", "+993", "🇹🇲"),
  C("UG", "Uganda", "+256", "🇺🇬"),
  C("UA", "Ukraine", "+380", "🇺🇦"),
  C("AE", "United Arab Emirates", "+971", "🇦🇪"),
  C("GB", "United Kingdom", "+44", "🇬🇧"),
  C("US", "United States", "+1", "🇺🇸"),
  C("UY", "Uruguay", "+598", "🇺🇾"),
  C("UZ", "Uzbekistan", "+998", "🇺🇿"),
  C("VE", "Venezuela", "+58", "🇻🇪"),
  C("VN", "Vietnam", "+84", "🇻🇳"),
  C("YE", "Yemen", "+967", "🇾🇪"),
  C("ZM", "Zambia", "+260", "🇿🇲"),
  C("ZW", "Zimbabwe", "+263", "🇿🇼"),
];

export const findCountry = (code) => COUNTRIES.find((c) => c.code === code) || COUNTRIES.find((c) => c.code === "IN");
